import { defineComponent, onMounted, onUnmounted } from 'vue';
import OverlappingCampaignsList
	from '@/presentation/components/shared/overlapping-campaigns-modal/overlapping-campaign-list/overlapping-campaigns-list.vue';
import OverlappingCampaignsModalCode from '@/presentation/components/shared/overlapping-campaigns-modal/overlapping-campaigns-modal.code';

export default defineComponent({
	components: {
		OverlappingCampaignsList
	},
	setup: () => {
		const code = new OverlappingCampaignsModalCode();

		onMounted(code.mounted.bind(code));
		onUnmounted(code.unmounted.bind(code));

		return {
			modalContent: code.modalContent,
			overlappingCampaignsCluster: code.overlappingCampaignsCluster
		};
	}
});
